const YOUTUBE_ID_PATTERN = /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/

export const resolveYoutubeMediaId = value => {
  if (!value) {
    return null
  }

  if (typeof value === 'string') {
    const trimmed = value.trim()

    if (!trimmed) {
      return null
    }

    const urlMatch = trimmed.match(YOUTUBE_ID_PATTERN)

    if (urlMatch) {
      return urlMatch[1]
    }

    if (/^[a-zA-Z0-9_-]{11}$/.test(trimmed)) {
      return trimmed
    }

    return null
  }

  if (typeof value === 'object') {
    return (
      resolveYoutubeMediaId(value.mediaId) ||
      resolveYoutubeMediaId(value.media_id) ||
      resolveYoutubeMediaId(value.embedId) ||
      resolveYoutubeMediaId(value.url) ||
      resolveYoutubeMediaId(value.id)
    )
  }

  return null
}

export const getActivityVideoMediaId = hit => resolveYoutubeMediaId(hit?.video)

export const getAssessmentVideoMediaId = hit =>
  resolveYoutubeMediaId(hit?.assessment_video) ||
  resolveYoutubeMediaId(hit?.assessmentVideo) ||
  resolveYoutubeMediaId(hit?.details?.assessment_video) ||
  resolveYoutubeMediaId(hit?.details?.assessmentVideo)
